import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
    useMemo,
} from 'react';

import {
    PAYMENT_PAGE_TYPE,
} from 'entities/payment-methods/constants';

import StageCard from '../StageCard';

import DetailField from './DetailField/DetailField';
import UpiIntentQr from './UpiIntentQr';
import UpiP2PQr from './UpiP2PQr';

import {
    filterDetailFields,
} from './helpers/filter-detail-fields';
import {
    formatSafeText,
} from './helpers/format-safe-text';

import shieldImage from './media/shield.svg';

import styles from './DetailFieldsCard.module.scss';

const DetailFieldsCard: FC<IProps> = (props) => {
    const detailFields = useMemo(() => {
        return filterDetailFields(props.paymentPageType, props.detailFields);
    }, [props.paymentPageType, props.detailFields]);

    return (
        <StageCard
            className={classNames(styles.detailFieldsCard, props.className)}
            number={1}
            title={props.detailFieldsBlockHint.title}
            description={props.detailFieldsBlockHint.description}
        >
            {
                props.paymentPageType === PAYMENT_PAGE_TYPE.UPI_P2P &&
                <UpiP2PQr
                    className={styles.upiP2PQr}
                    detailFields={props.detailFields}
                    amountKopecks={props.amountKopecks}
                />
            }
            {
                props.paymentPageType === PAYMENT_PAGE_TYPE.UPI_INTENT_QR ?
                    <UpiIntentQr
                        className={styles.upiIntentQr}
                        payment={props.payment}
                        onPending={props.onPending}
                    /> :
                    <div className={styles.list}>
                        {
                            detailFields.map(
                                (detailField) =>
                                    <DetailField
                                        key={detailField.key}
                                        detailField={detailField}
                                    />
                            )
                        }
                    </div>
            }
            <div className={styles.safe}>
                <img
                    className={styles.shieldImage}
                    src={shieldImage}
                    alt={'Safe account'}
                />
                {formatSafeText(props.paymentPageType)}
            </div>
        </StageCard>
    );
};

export default DetailFieldsCard;
